import { Injectable } from '@angular/core';
import { MessagesService } from './messages.service';
import { MessagesState } from './messages.state';
import { map, take, debounceTime, tap, distinctUntilChanged } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { Message } from '../interfaces/Message';
import { MessageBody } from '../interfaces/MessageBody';
import { GlobalService } from 'src/app/_services/global.service';
import { DataService } from 'src/app/dashboard/_services/data.service';

@Injectable({
    providedIn: 'root'
})

export class MessagesFacade {

    constructor(private messagesApi: MessagesService, private messagesState: MessagesState, private globalService: GlobalService,private dataService: DataService) { }
    infiniteScrollSpinner: boolean = false;
    isLoading: boolean = false;

    // private _reloadMessages = new BehaviorSubject<boolean>(null);
    // reloadMessages = this._reloadMessages.asObservable();

    setReloadMessages(reloadState) {
        this.messagesApi.setReloadMessages(reloadState);
    }

    getReloadMessages() {
        return this.messagesApi.getReloadMessages();
    }




    loadAllMessages(perPage: number = 25, page: number = 1) {
        this.isLoading = true
        this.globalService.startLoading();
        // this.messagesApi.getMessages(perPage, page)
        this.dataService.getAllMessages().pipe(map((data: any) => data.data)).subscribe(messages => {
            this.messagesState.setAllMessages(messages);
            this.getCurrentPage$().pipe().subscribe(page => {
                // this.setMessageListView(10, page);
                if(page > 1){
                    this.setMessageListView(10, page);
                }
            })
            this.messagesState.setMessagesCompactView(messages);
            this.isLoading = false
            this.globalService.stopLoading();

        });
        this.messagesApi.getMessagesCount$().pipe().
            subscribe((data: any) => this.messagesState.setMessagesCount(data.length))
    }


    setMessageCount(searchText?: string) {
        this.messagesApi.getMessagesCount$(searchText).pipe().
            subscribe((data: any) => this.messagesState.setMessagesCount(data.length))
    }

    getMessageCount$() {
        return this.messagesState.getMessageCoun$()
    }


    getAllMessages$(): Observable<Message[]> {
        return this.messagesState.getMessages$();
    }

    setMessagesCompactView(itemsPerPage, page, sortType, searchText?: string) {
        // this.isLoading = true;
        if (searchText) {
            return this.messagesApi.getMessages(itemsPerPage, page, sortType, searchText).pipe(debounceTime(500), distinctUntilChanged())
        }

        else { return this.messagesApi.getMessages(itemsPerPage, page) }
    }

    sortMessages(itemsPerPage, page, sortType, searchText?: string) {
        if (!searchText) {
            this.messagesApi.getMessages(itemsPerPage, page, sortType).pipe(map((data: any) => data.data)).subscribe(res => {
                this.messagesState.setMessagesCompactView(res);
                this.isLoading = false;

                this.globalService.stopLoading();
            })
            return
        }
        this.messagesApi.getMessages(itemsPerPage, page, sortType, searchText).pipe(map((data: any) => data.data)).subscribe(res => {
            this.messagesState.setMessagesCompactView(res);
            this.isLoading = false;
            this.globalService.stopLoading();

        })

    }
    setMessagesCompactViewState(messages) {
        this.messagesState.setMessagesCompactView(messages)
    }


    getMessagesCompactView$(): Observable<Message[]> { //compact
        return this.messagesState.getMessagesCompactView$();
    }

    setMessageListView(itemsPerPage, page) {
        this.infiniteScrollSpinner = true;
        this.messagesApi.getMessages(itemsPerPage, page).pipe(map((data: any) => data.data)).subscribe(res => {
            this.messagesState.setAllMessages(res)
            this.infiniteScrollSpinner = false;
        }
        )
    }

    setMessageById(id: number) {
        this.getAllMessages$().pipe(map(messages => messages.filter(message => message.id == id))).subscribe(currentMessage => {
            this.messagesState.setCurrentMessage(currentMessage)
        })
    }

    getCurrentMessage$() {
        return this.messagesState.getCurrentMessage$();
    }

    getAllRoles$() {
        return this.messagesApi.getAllRoles();
    }

    setCurrentPage() {
        this.messagesState.setCurrentPage()
    }

    getCurrentPage$() {
        return this.messagesState.getCurrentPage$()
    }

    searchMessages(perPage: number, page: number, searchText: string) {
        return this.messagesApi.searchMessages(perPage, page, searchText)
    }

    deleteMessage(messageId) {
        return this.messagesApi.deleteMessage(messageId)
    }


}